export const START_COURSE = 'START_COURSE'
export const GET_ADMINS = 'GET_ADMINS'
export const SAVE_ADMINS = 'SAVE_ADMINS'

export const GET_MEMBERS = 'GET_MEMBERS'
export const SET_MEMBERS = 'SET_MEMBERS'

export const NEW_QUESTION = 'NEW_QUESTION'
export const EDIT_QUESTION = 'EDIT_QUESTION'
export const DELETE_QUESTION = 'DELETE_QUESTION'

export const START_TEST = 'START_TEST' // начать прохождение теста
export const SEND_ANSWER = 'SEND_ANSWER' // отправка ответа на вопрос
export const END_TEST = 'END_TEST' // ручное завершение если не завершать автоматически на последнем вопросе

export const LEARN_LESSON = 'LEARN_LESSON' // получение прогресса сотрудника по указанному курсу в целом
export const GET_USER_PROGRESS = 'GET_USER_PROGRESS' // получение прогресса сотрудника по указанному курсу в целом
export const GET_ANALYTIC = 'GET_ANALYTIC' // получение аналитики (любая, зависит от параметров)
export const GET_TEST_STAT = 'GET_TEST_STAT' // получение статистики по одному тесту
export const GET_LESSON_STAT = 'GET_LESSON_STAT' // получение статистики по одному уроку
export const GET_DASHBOARD_DATA = 'GET_DASHBOARD_DATA' // получение статистики по всей компании в сумме
